import React, { forwardRef, useEffect, useState } from 'react'
import QRCode from 'qrcode'
import { Icon, Modal, Image } from '..'

export default forwardRef(function QrcodeModal({ url, style, ...props }, ref) {
    const [二维码图片, 设置二维码图片] = useState()
    
    useEffect(() => {
        设置二维码图片(null)
        QRCode.toDataURL(url, (err, qrcode_url) => {
            设置二维码图片(qrcode_url)
        })
    }, [url])

    return <Modal ref={ref} onCancel={() => ref.current.hide()}>
        <div style={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            ...style
        }} {...props}>
            <Image src={require('./images/box.png')} style={{
                windth: '500px'
            }} />
            {
                二维码图片 && <Image src={二维码图片} style={{
                    position: 'absolute',
                    top: '103px',
                    left: '135px',
                    windth: '232px',
                    height: '232px'
                }} />
            }
            <Icon name="danchuangguanbi" style={{
                marginTop: '50px',
                fontSize: '40px',
                color: '#fff',
                cursor: 'pointer'
            }} />
        </div>
    </Modal>
})
